import { Delta } from "quill";

const QUILL_URL_REGEXP = /(?:https?:\/\/|www\.)[\w-.]+\.[\w-.]+(?:\/(?:\S+)?)?/gi;

export const autoFormatUrls = (quillInstance) => {
  
  const range = quillInstance.getSelection();
  const end = range.index;
  let text = quillInstance.getText(0, end);
  const start = text.matchAll(/\s/g).toArray().slice(-1)[0]?.index;
  text = quillInstance.getText(start, end-start);
  
  const matches = text.matchAll(QUILL_URL_REGEXP).toArray();
  
  if(!matches.length)
    return;
  
  let delta = new Delta();
  
  for (const match of matches) {
    const url = match[0];
    const index = start + (match.index ?? 0); // Ensure index isn't undefined
    
    // Ensure URL is not already a link
    const formats = quillInstance.getFormat(index, url.length);
    
    if (!formats.link) {
      const linkDelta = quillInstance.formatText(index, url.length, { ...formats, link: url }, "api");
      delta = delta.compose(linkDelta);
      console.log(delta);
    }
  }
  
  return delta;
}

export const formatUrlOnPaste = (event, quillInstance) => {
  if(event.html)
    return;
  
  let ops = [];
  const range = quillInstance.getSelection();
  const pastedText = event.clipboardData.getData('text/plain');
  
  let newSelection = range.index;
  
  if(!pastedText || typeof pastedText !== "string")
    return;
  
  let lastMatchEndIndex = 0;
  let matches = pastedText.matchAll(QUILL_URL_REGEXP).toArray();
  
  if(!matches.length)
    return;
  
  event.preventDefault();
  
  if(matches.length === 1 && matches[0][0].length === pastedText.length && range.length > 0) {
    ops = quillInstance.getContents(range.index, range.length)?.ops;
    
    ops.forEach((content) => {
      if(content.attributes)
        content.attributes.link = pastedText;
      else
        content.attributes = { link: pastedText };
    })
    
    newSelection += quillInstance.getText(range.index, range.length)?.length || 0;
    
  } else for (const match of matches) {
    const url = match[0];
    const index = match.index ?? 0;
    
    if (index > lastMatchEndIndex) {
      ops.push({ insert: pastedText.slice(lastMatchEndIndex, index) });
    }
    
    ops.push({ insert: url, attributes: { link: url } });
    lastMatchEndIndex = index + url.length;
    
    newSelection += pastedText.length;
  }
  
  quillInstance.updateContents([{retain: range.index}, {delete: range.length}, ...ops], "user");
  quillInstance.setSelection(newSelection)
}